import { render, staticRenderFns } from "./scopecenter4.vue?vue&type=template&id=027e3e6e&scoped=true"
import script from "./scopecenter4.vue?vue&type=script&lang=js"
export * from "./scopecenter4.vue?vue&type=script&lang=js"
import style0 from "./scopecenter4.vue?vue&type=style&index=0&id=027e3e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e3e6e",
  null
  
)

export default component.exports